var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIceHockey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.484,
    cy: 5.729,
    fill: "#509CF2",
    rx: 6.484,
    ry: 2.418
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M7.484 8.148c3.58 0 6.482-1.083 6.482-2.419l-.09.089c-.547.525-2.206 1.957-6.392 1.957-4.455 0-6.305-1.449-6.484-2.046 0 1.336 2.902 2.419 6.484 2.419z",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#509CF2",
    d: "M1.034 6.452c0 1.336 2.902 2.418 6.482 2.418C11.098 8.87 14 7.788 14 6.452v2.882c-.09 1.306-2.959 2.355-6.484 2.355-3.523 0-6.394-1.049-6.482-2.355V6.452z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M7.79 11.003c5.575-.25 6.21-3.215 6.21-4.551v2.882c-.09 1.306-2.959 2.355-6.484 2.355-3.523 0-6.394-1.049-6.482-2.355.787 1.28 3.04 1.836 6.756 1.669z",
    opacity: 0.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIceHockey);
export default __webpack_public_path__ + "static/media/ice_hockey.670df38cad928b77c443749e65b5ffd6.svg";
export { ForwardRef as ReactComponent };